import { Outlet } from 'react-router-dom'
import { AdminSidebar } from './AdminSidebar'

/**
 * Layout for /admin/* routes (ADMINISTRATOR only).
 *
 * A near-clone of AppLayout minus the tenant-specific bits:
 *   - no useParams<{ companyId }>() — admin routes aren't tenant-scoped
 *   - no per-company name fetch in the header
 *   - no PbxCertBanner (admins don't place calls)
 *
 * If the two layouts ever drift further, factor a thin shared frame
 * later. Don't pay that abstraction cost up front (see codex critique
 * in docs/admin-dashboard.md §3).
 */
export function AdminLayout() {
  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <AdminSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
